import React from 'react';
import Store from '../store/Store';
import StoreListener from '../store/StoreListener';
import { SUCCESS_DIALOG_MSG } from '../store/Constants';
import t from '../i18n/I18n';
import Modal2 from '../modals/Modal2';
import ConfirmModal from '../modals/confirm/ConfirmModal';
import { directorySelector } from '../util/MainThreadUtil';
import ClientUpdateTPMQuery from '../queries/tpm/ClientUpdateTPMQuery';
import SaveSettings from '../queries/settings/SaveSettings';

export const TPM_DIALOG_MSG = 'TPM_MSG';

export const SuccessDailog = function(props) {
  return (
    <Modal2
      title={t('CONFIRMATION_TITLE')}
      buttons={[{ label: t('CLOSE'), type: 'CANCEL', onClick: props.closeModal }]}
      closeOnEsc
      showCrossIcon={false}
      closeOnOutsideClick>
      {props.msg}
    </Modal2>
  );
};

const storeItems = [SUCCESS_DIALOG_MSG];

@StoreListener(storeItems)
export default class SuccessToast extends React.Component<Props, State> {
  hide = () => {
    Store.put(SUCCESS_DIALOG_MSG, null);
  };

  onYes = () => {
    directorySelector(this.onFileSelect, {name: 'TPM'});
  };

  onFileSelect = async (paths) => {
    if (paths && paths.length) {
      const tpmQuery = new ClientUpdateTPMQuery(paths[0]);
      const promise = tpmQuery.run().then((resp) => { SaveSettings.updateSettings(); });
      await promise;
    }
    this.hide();
  };

  render() {
    const msg = this.props[SUCCESS_DIALOG_MSG];
    if (!msg) return null;
    if (msg === TPM_DIALOG_MSG)
      return <ConfirmModal onClose={this.hide} moveAsset={this.onYes} message={t('NO_VALID_TPM_PRESENT')} title=" " />;
    return <SuccessDailog msg={msg} closeModal={this.hide} />;
  }
}
